import { getMembership } from "@jog/shared"
import { Membership } from "@jog/types"
import { PropsWithChildren, createContext, useCallback, useContext, useEffect, useMemo, useState } from "react"

import { useMe } from "./useMe"

interface MembershipState {
    pending: boolean
    error: string
    membership: Membership | null
}

const MembershipContext = createContext<MembershipState>({
    pending: true,
    error: "",
    membership: null,
})

export const MembershipProvider = ({ children }: PropsWithChildren) => {
    const [pending, setPending] = useState(true)
    const [error, setError] = useState("")
    const { user } = useMe()
    const [membership, setMembership] = useState<Membership | null>(null)
    const fetch = useCallback(async () => {
        setPending(true)
        setError("")
        await getMembership()
            .then((res) => res.body.membership)
            .then((membership) => setMembership(membership || null))
            .catch((e: Error) => {
                setError(e.message)
            })
            .finally(() => {
                setPending(false)
            })
    }, [])
    useEffect(() => {
        if (user) {
            fetch()
        }
    }, [user, fetch])
    const value = useMemo(() => ({ pending, error, membership }), [error, membership, pending])
    return <MembershipContext.Provider value={value}>{children}</MembershipContext.Provider>
}

export const useMembership = () => useContext(MembershipContext)
